import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {}

  /**
  * Provides an error boundary wrapper that catches errors from child components, displays a recovery UI, and otherwise renders its children.
  * @component
  * @example
  *   <ErrorBoundary>
  *     <App />
  *   </ErrorBoundary>
  * @prop {React.ReactNode} children - The components that are being protected by the error boundary; rendered when no error has been caught.
  **/
  render() {
    if (this.state.hasError) {
      return (
        <div className="p-4 text-center">
          <p className="text-red-500 mb-2">Failed to load component</p>
          <button 
            onClick={() => window.location.reload()} 
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
